var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { store } from "./store";


const ProtectedRoute = ({
  children,
  allowedRoles



}) => {
  const userId = store === null || store === void 0 ? void 0 : store.getState().user.get('_id');
  const userRole = (store === null || store === void 0 ? void 0 : store.getState().user.get('role')) || '';
  if (allowedRoles && allowedRoles.includes(userRole)) {
    return children || /*#__PURE__*/_jsx(Outlet, {});
  }

  if (!allowedRoles && userId) {
    return children || /*#__PURE__*/_jsx(Outlet, {});
  }

  return /*#__PURE__*/_jsx(Navigate, { to: "/login", replace: true });
};

const adminsOnlyRoute = (element) => /*#__PURE__*/
_jsx(ProtectedRoute, { allowedRoles: ['admin'] }, void 0, element);


const privateRoute = (element, settings) =>
!(settings !== null && settings !== void 0 && settings.private) ? element : /*#__PURE__*/_jsx(ProtectedRoute, {}, void 0, element);

const loggedInUsersRoute = (element) => /*#__PURE__*/_jsx(ProtectedRoute, {}, void 0, element);
export { loggedInUsersRoute, adminsOnlyRoute, privateRoute, ProtectedRoute };